// extracted by mini-css-extract-plugin
module.exports = {"FutureBenefits":"FutureBenefits_FutureBenefits__nY3wJ","HowGet":"FutureBenefits_HowGet__S8wXo","HowUse":"FutureBenefits_HowUse__LN2Ow"};